export const GET_RECOM_PRODUCT_SUCCESS = "getRecommondedProductSuccess";
export const GET_RECOM_PRODUCT_FAIL = "getRecommondedProductFail";
